"use client";

import { useLocale } from "next-intl";
import React, { type ReactElement } from "react";
import {
  GlossaryDefinitionList,
  GlossaryNav,
  GlobalPageHeader,
} from "@/components";
import { useTags } from "src/hooks/sites";
import { Tag } from "@/types";
import { getApplication } from "@/services/applications";

interface GlossaryMainProps {
  tags: Tag[];
}

function GlossaryMain({ tags }: Readonly<GlossaryMainProps>): ReactElement {
  const application = getApplication("glossary");
  const locale = useLocale();
  const { groupTagsAlphabetically } = useTags(tags);
  const groupedTags = groupTagsAlphabetically(locale);
  const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

  return (
    <>
      <GlobalPageHeader
        title={application!.title[locale]}
        lead={application!.lead[locale]}
      />
      <GlossaryNav tags={groupedTags} />
      <section className="relative max-w-7xl mx-auto px-4 flex flex-col gap-8 bg-background">
        {alphabet.map((letter) => {
          if (groupedTags[letter]) {
            return (
              <div
                className="scroll-mt-[calc(--globalnav-height+56px)]"
                id={letter}
                key={`list-${letter}`}
              >
                <h4 className="sticky top-[96px] p-0 m-0 h-12 flex items-end text-sm uppercase font-semibold pb-1 border-b border-border bg-background">
                  {letter}
                </h4>
                {groupedTags[letter] ? (
                  <GlossaryDefinitionList tags={groupedTags[letter]} />
                ) : null}
              </div>
            );
          }
        })}
      </section>
    </>
  );
}

export { GlossaryMain, type GlossaryMainProps };
